<script setup lang="ts">
defineProps<{
  vertical?: boolean;
  /**
   * Applies different border styles to the divider element.
   * Usually this version should be used on white backgrounds
   * On dark/gray backgrounds - the default version should be used.
   */
  lighter?: boolean;
  text?: string;
}>();
</script>

<template>
  <div
    class="u-divider"
    :class="{ 'u-divider--lighter': lighter, 'u-divider--vertical': vertical }"
  >
    <hr>

    <span v-if="text" class="text-xs font-medium text-neutral-light-800 dark:text-neutral-dark-200">{{ text }}</span>

    <hr v-if="text">
  </div>
</template>

<style lang="scss">
.u-divider {
  @apply flex gap-3.5 items-center;
  hr {
    @apply flex-1 border-neutral-light-300 dark:border-neutral-dark-700;
  }
  &.u-divider--lighter hr {
    @apply border-neutral-light-200 dark:border-neutral-dark-900;
  }
  &.u-divider--vertical {
    @apply inline-flex flex-col h-full;
    hr {
      @apply w-0 max-w-0 border-l border-t-0;
    }
  }
}
</style>
